export const GetInsurancesBlockDocumentationMarkdown = `
### Get Insurances
Extract patient insurances from Notable database corresponding to Start block's output entity.
`;
